/**
 * 關閉地區語系彈窗之後就不再顯示，此功能的相關函式
 *
 * @returns {
 *   SESSION_KEY: 儲存在 sessionStorage 的 key,
 *   getClosedPopUpRegions: 取得已關閉的地區語系列表,
 *   setClosedPopUpRegions: 設定已關閉的地區語系
 * }
 */

export function useClosedPopUpRegions() {
  const SESSION_KEY = 'closed_popup_regions';

  const getClosedPopUpRegions = (): string[] => {
    if (import.meta.client) {
      const data = sessionStorage.getItem(SESSION_KEY);

      if (data) {
        try {
          const parsed = JSON.parse(data);

          if (Array.isArray(parsed)) {
            return parsed;
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return [];
  };

  const setClosedPopUpRegions = (regionCode: EnumRegion | null): void => {
    const closedList = getClosedPopUpRegions();
    const closedListSet: Set<string> = new Set(closedList);
    if (regionCode) {
      closedListSet.add(regionCode);
      const result = Array.from(closedListSet);
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(result));
    }
  };

  return {
    SESSION_KEY,
    getClosedPopUpRegions,
    setClosedPopUpRegions,
  };
}
